import styled from 'styled-components';

export const StyledToggle = styled.div`
  display: flex;
  flex-direction: row;
  background: ${({ theme, $isOn }) => $isOn ? theme.buttonGreen : 'rgba(0, 0, 0, 0.36)'};
  cursor: pointer;
  width: min-content;
  border: solid 2px transparent;

  &:hover {
    border: solid 2px ${({ theme }) => theme.buttonDarkGreen};
  }

  .toggle-handle-container {
    margin: 2px;
    width: calc(${({ theme }) => theme.toggleHandleSize} * 2);
  }

  .toggle-handle {
    width: ${({ theme }) => theme.toggleHandleSize};
    height: ${({ theme }) => theme.toggleHandleSize};
    background: ${({ theme, $isOn }) => $isOn ? 'white' : theme.buttonGreen};
    border: solid 2px ${({ theme }) => theme.borderGreen};
    transition: transform linear 0.1s;
    transform: ${({ $isOn }) => $isOn ? 'translateX(100%)' : 'translateX(0%)'};
  }
`;
